module.exports = __webpack_public_path__ + "img/compromiso.83b34312.svg";